import { c as _c } from "react/compiler-runtime";
import { Empty, EmptyDescription, EmptyHeader, EmptyTitle } from '@achra/ui/empty';
function NoBuildersFound() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Empty><EmptyHeader><EmptyTitle>No builders found</EmptyTitle><EmptyDescription>There are no builders to display at this time.</EmptyDescription></EmptyHeader></Empty>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export { NoBuildersFound };